// src/services/sucursalService.ts
import { axiosInstance } from '../axiosConfig';
import { handleRequestWithAuth } from '../refreshService';

const API_URL = 'sucursales/';

// Interfaz para Sucursal
export interface Sucursal {
    id: number;
    nombre: string;
    direccion: string;
    codigo: string;
    telefono: string | null;
    email: string | null;
    activo: boolean;
    fecha_creacion: string;
}

// Obtener todas las sucursales
export const fetchSucursales = async (): Promise<Sucursal[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

// Obtener una sucursal por ID
export const fetchSucursal = async (id: number): Promise<Sucursal> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/`);
        return response.data;
    });
};

// Crear una nueva sucursal
export const createSucursal = async (data: {
    nombre: string;
    direccion: string;
    codigo: string;
    telefono?: string | null;
    email?: string | null;
    activo?: boolean;
}): Promise<Sucursal> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// Actualizar una sucursal existente
export const updateSucursal = async (
    id: number,
    data: {
        nombre?: string;
        direccion?: string;
        codigo?: string;
        telefono?: string | null;
        email?: string | null;
        activo?: boolean;
    }
): Promise<Sucursal> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.patch(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// Eliminar una sucursal
export const deleteSucursal = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};
